// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"bcz_a bhg_rh bhg_ri bhg_vf bhg_ec bhg_vc bhg_gs bhg_kf"};